<template>
  <div class="l-loading">
    <c-loading :msg="''"/>
  </div>
</template>

<script>
import CLoading from '@/components/CLoading.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoadingScreen',
  props: {
    callback: Function,
    lastView: String,
    routeName: String,
    timeOut: Number
  },
  components: {
    CLoading
  },
  computed: {
    ...mapGetters({
      lastViewStore: 'Loading/lastView'
    })
  },
  methods: {
    ...mapActions([
      'Loading/setLastView'
    ])
  },
  created () {
    document.title = this.$options.name
    if (this.lastView) {
      this['Loading/setLastView']({ lastView: this.lastView })
    }
    setTimeout(() => {
      if (this.callback) {
        if (this.routeName && this.routeName.length > 0) {
          this.callback(this.routeName)
        }
        this.callback()
      } else {
        let defaultLink
        if (this.lastView) {
          defaultLink = this.lastView
        } else if (this.lastViewStore) {
          defaultLink = this.lastViewStore
          this['Loading/setLastView']({ lastView: null })
        } else {
          defaultLink = 'Home'
        }
        if (this.$route.params.redirectTo) {
          defaultLink = this.$route.params.redirectTo
        }
        this.$router.push({ name: defaultLink })
      }
    }, this.timeOut || 2000)
  },
  watch: {
    lastView (val) {
      if (val) {
        this['Loading/setLastView']({ lastView: val })
      }
    }
  }
}
</script>

<style scoped>
  .l-loading {
    background: #ffffff;
    height: 100%;
  }
</style>
